import styled from "styled-components";

const ProfileCard = ({ department, nickname }) => {
  return (
    <Layout>
      <ProfileImg />
      <ProfileName>
        <p style={{ color: "#02C373" }}>{department}</p>
        <p>{nickname}</p>
      </ProfileName>
    </Layout>
  );
};

export default ProfileCard;

const Layout = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 14px;
  border-radius: 10px;
  border: 1px solid #000;
  background: #fff;
`;

const ProfileImg = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background: #d9d9d9;
`;

const ProfileName = styled.div`
  display: flex;
  gap: 4px;
`;
